import Image from "next/image";

export function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-secondary/30 backdrop-blur-sm z-50">
      <div className="relative flex flex-col items-center">
        <div className="w-24 h-24 relative">
          {/* Logo animato */}
          <div className="absolute inset-0 animate-pulse">
            <Image
              src="/logo-2.png"
              alt="Loading..."
              width={96}
              height={96}
              className="w-full h-full object-contain"
              priority
            />
          </div>
        </div>
        {/* Cerchio di caricamento */}
        <div className="absolute -inset-3">
          <div className="w-[120px] h-[120px] rounded-full border-4 border-transparent border-t-primary animate-spin-fast" />
        </div>
      </div>
    </div>
  );
}